import React from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faInstagram,
  faYoutube,
  faTiktok,
} from "@fortawesome/free-brands-svg-icons";

function Footer() {
  const navigate = useNavigate();

  return (
    <footer style={styles.footer}>
      <div style={styles.footerContent}>
        {/* Contact Details */}
        <div style={styles.contactDetails}>
          <p style={styles.contactText}>livtubrand@gmail.com</p>
          <p style={styles.contactText}>+40 741 232 128</p>
          <div style={styles.socialIcons}>
            <a
              href="https://web.facebook.com/LivTuVisitYourCity"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.iconLink}
              aria-label="Facebook Page"
            >
              <FontAwesomeIcon icon={faFacebookF} style={styles.icon} />
            </a>
            <a
              href="https://www.instagram.com/livtuvisit/"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.iconLink}
              aria-label="Instagram Profile"
            >
              <FontAwesomeIcon icon={faInstagram} style={styles.icon} />
            </a>
            <a
              href="https://www.youtube.com/@LivTuVisit"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.iconLink}
              aria-label="YouTube Channel"
            >
              <FontAwesomeIcon icon={faYoutube} style={styles.icon} />
            </a>
            <a
              href="https://www.tiktok.com/@livtuvisityourcity?is_from_webapp=1&sender_device=pc"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.iconLink}
              aria-label="TikTok Profile"
            >
              <FontAwesomeIcon icon={faTiktok} style={styles.icon} />
            </a>
          </div>
        </div>

        {/* Reservation Section */}
        <div style={styles.reservationSection}>
          <button
            style={styles.reservationButton}
            onClick={() => navigate("/contact")}
          >
            Rezervă o excursie
          </button>
          <p style={styles.appointmentText}>O experiență de neuitat</p>
        </div>
      </div>

      {/* Centered Text Section */}
      <div style={styles.centerSection}>
        <p style={styles.address}>
          Planifică următoarea ta aventură în: <br />
          Sibiu · București · Horezu · Băile Olănești · Râmnicu Vâlcea · Târgu Mureș ·
          Călimănești · Târgoviște · Băile Govora
        </p>
        <p style={styles.footerText}>
          © 2025 Creat de Satris Company. Bucură-te de călătorii în siguranță!
        </p>
        <p style={styles.termsText}>
          <a href="/termeni-si-conditii" style={styles.termsLink}>
            Termeni și Condiții
          </a>
        </p>
      </div>
    </footer>
  );
}

const styles = {
  footer: {
    backgroundColor: "#2C2C2C",
    color: "#FFFFFF",
    padding: "2rem 1rem",
    fontFamily: "'Georgia', serif",
  },
  footerContent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    flexWrap: "wrap",
    gap: "2rem",
  },
  contactDetails: {
    flex: "1",
    maxWidth: "300px",
  },
  contactText: {
    margin: "0.5rem 0",
    color: "#FFFFFF",
  },
  socialIcons: {
    display: "flex",
    gap: "1rem",
    marginTop: "1rem",
  },
  iconLink: {
    color: "#FFFFFF",
    fontSize: "1.5rem",
    transition: "color 0.3s ease",
  },
  icon: {
    cursor: "pointer",
  },
  reservationSection: {
    flex: "1",
    maxWidth: "400px",
    textAlign: "center",
  },
  reservationButton: {
    padding: "0.8rem 1.5rem",
    backgroundColor: "transparent",
    border: "2px solid #C39A79",
    color: "#C39A79",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "1rem",
    transition: "color 0.3s, border-color 0.3s",
  },
  appointmentText: {
    marginTop: "0.5rem",
    color: "#CCCCCC",
    fontSize: "0.9rem",
  },
  centerSection: {
    textAlign: "center",
    marginTop: "2rem",
  },
  address: {
    fontSize: "0.9rem",
    color: "#CCCCCC",
    lineHeight: "2",
  },
  footerText: {
    fontSize: "0.9rem",
    color: "#CCCCCC",
    lineHeight: "1.4",
    marginBottom: "1rem",
  },
  termsText: {
    fontSize: "0.9rem",
    marginTop: "1rem",
  },
  termsLink: {
    color: "#CCCCCC",
    textDecoration: "underline",
    cursor: "pointer",
  },
};

export default Footer;
